import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { motion } from 'framer-motion';
import { SilentModeWarning } from '@/components/popups/SilentModeWarning';
import { Button } from '@/components/ui/button';
import Text from '@/components/ui/text';
import Title from '@/components/ui/title';
import { assets } from '@/lib/assets';
import { playSound, stopSound } from '@/lib/utils/playSound';
import { GameOrder, useGameData } from '@/providers/GameDataProvider';

export default function PageIntro() {
  const { t } = useTranslation();
  const { resetGameScores } = useGameData();
  const navigate = useNavigate();

  const handleContinue = () => {
    // we want to reset all the game scores!
    resetGameScores();
    navigate(GameOrder[0]);
  };

  useEffect(() => {
    playSound(assets.sounds.introMusic, { loop: true });
    return () => {
      stopSound(assets.sounds.introMusic, 1000, true);
    };
  }, []);

  return (
    <>
      <div className="flex h-screen flex-col pb-10 text-center md:justify-center">
        <motion.img
          src="content/images/heroes.webp"
          alt="logo"
          className="max-h-[60vh] min-h-0 w-full flex-shrink object-contain"
        />

        <Title i18nKey="intro.title" className="text-4xl" />
        <div className="flex-grow flex-col px-10 pt-1 text-center md:pt-4">
          <Text i18nKey="intro.description" />

          <div className="flex-grow flex-col justify-center py-10">
            <Button
              variant="secondary"
              className="w-60"
              onClick={handleContinue}
            >
              {t('intro.button.continue')}
            </Button>
          </div>
        </div>
      </div>

      <SilentModeWarning />
    </>
  );
}
